import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/products";

class ProductsService {
  getProducts = async ({ page = 1, sortBy = "", search = "" } = {}) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`, {
        params: {
          page,
          sortBy,
          search,
        },
      });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching products.");
    }
  };

  getProduct = async (id) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching product.");
    }
  };

  getProductsByCategory = async ({
    id,
    page = 1,
    sortBy = "",
    search = "",
  } = {}) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/category/${id}`, {
        params: {
          page,
          sortBy,
          search,
        },
      });

      if (response.status !== 200) {
        throw new Error();
      }

      return { data: response.data, categoryName: id };
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching products by category."
      );
    }
  };

  getCategories = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/categories`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching categories.");
    }
  };

  createCategory = async (requestData) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/category`,
        requestData
      );
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating category.");
    }
  };

  updateCategory = async (id, requestData) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/category/${id}`,
        requestData
      );
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri izmeni kategorije.");
    }
  };

  deleteCategory = async (id) => {
    try {
      const response = await axiosApiClient.delete(
        `${BASE_URL}/category/${id}`
      );
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting category.");
    }
  };

  createProduct = async (requestData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, requestData);
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating product.");
    }
  };

  editProduct = async (id, requestData) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/${id}`,
        requestData
      );
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while editing product.");
    }
  };

  deleteProduct = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting product.");
    }
  };

  deletePhoto = async (productId, photoId) => {
    try {
      const response = await axiosApiClient.delete(
        `${BASE_URL}/${productId}/photos/${photoId}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri brisanju fotografije.");
    }
  };
}
const productsService = new ProductsService();

export default productsService;
